/* ============================================================
   EARL & ETHEL THEME — JavaScript
   ============================================================ */

(function() {
  'use strict';

  // ── 1. DOM Ready ──────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function() {
    initHeader();
    initProductGallery();
    initProductVariants();
    initQuantitySelectors();
    initGiftCredit();
    initCartItems();
    initSortBy();
    initMobileMenu();
    initSearchToggle();
    initAddToCart();
    initHeroRotator();
  });

  // ── Hero headline rotator ─────────────────────────────────
  function initHeroRotator() {
    var rotators = document.querySelectorAll('[data-hero-rotator]');
    rotators.forEach(function(rotator) {
      var items = rotator.querySelectorAll('.hero-banner__rotator-item');
      if (items.length < 2) return;
      // Respect users who prefer reduced motion: leave the first phrase static
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var interval = (parseFloat(rotator.getAttribute('data-interval')) || 3) * 1000;
      if (interval < 1500) interval = 1500;
      var idx = 0;
      setInterval(function() {
        items[idx].classList.remove('is-active');
        idx = (idx + 1) % items.length;
        items[idx].classList.add('is-active');
      }, interval);
    });
  }

  // ── 2. Header ─────────────────────────────────────────────
  function initHeader() {
    const header = document.getElementById('SiteHeader');
    if (!header) return;

    // Sticky header shadow on scroll
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const currentScroll = window.scrollY;
      if (currentScroll > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // ── 3. Mobile Menu ────────────────────────────────────────
  function initMobileMenu() {
    const toggle = document.getElementById('MenuToggle');
    const menu = document.getElementById('MobileMenu');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function() {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !isOpen);
      menu.hidden = isOpen;
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });

    // Sub-menu toggles
    const subToggles = menu.querySelectorAll('.mobile-menu__toggle');
    subToggles.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !isOpen);
        const sub = btn.nextElementSibling;
        if (sub) sub.hidden = isOpen;
        const caret = btn.querySelector('.icon-caret');
        if (caret) {
          caret.style.transform = isOpen ? '' : 'rotate(180deg)';
        }
      });
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (!menu.hidden && !menu.contains(e.target) && !toggle.contains(e.target)) {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        document.body.style.overflow = '';
      }
    });
  }

  // ── 4. Search Toggle ──────────────────────────────────────
  function initSearchToggle() {
    const toggleBtn = document.getElementById('SearchToggle');
    const searchBar = document.getElementById('SearchBar');
    const closeBtn = document.getElementById('SearchClose');
    if (!toggleBtn || !searchBar) return;

    toggleBtn.addEventListener('click', function() {
      const isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', !isOpen);
      searchBar.hidden = isOpen;
      if (!isOpen) {
        const input = searchBar.querySelector('input');
        if (input) input.focus();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        toggleBtn.setAttribute('aria-expanded', 'false');
        searchBar.hidden = true;
        toggleBtn.focus();
      });
    }

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !searchBar.hidden) {
        toggleBtn.setAttribute('aria-expanded', 'false');
        searchBar.hidden = true;
        toggleBtn.focus();
      }
    });
  }

  // ── 5. Product Gallery ────────────────────────────────────
  function initProductGallery() {
    const gallery = document.getElementById('ProductGallery');
    if (!gallery) return;

    const slides = gallery.querySelectorAll('.product-gallery__slide');
    const thumbs = gallery.querySelectorAll('.product-gallery__thumb');

    function setActive(mediaId) {
      slides.forEach(function(slide) {
        slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId);
      });
      thumbs.forEach(function(thumb) {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
      });
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        setActive(thumb.dataset.mediaId);
      });
    });

    // Touch/swipe support
    const main = document.getElementById('ProductGalleryMain');
    if (main) {
      let startX = 0;
      main.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
      }, { passive: true });

      main.addEventListener('touchend', function(e) {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          const activeSlide = gallery.querySelector('.product-gallery__slide.is-active');
          const allSlides = Array.from(slides);
          const currentIndex = allSlides.indexOf(activeSlide);
          let nextIndex;
          if (diff > 0) {
            nextIndex = (currentIndex + 1) % allSlides.length;
          } else {
            nextIndex = (currentIndex - 1 + allSlides.length) % allSlides.length;
          }
          setActive(allSlides[nextIndex].dataset.mediaId);
        }
      }, { passive: true });
    }
  }

  // ── 6. Product Variants ───────────────────────────────────
  function initProductVariants() {
    const form = document.getElementById('ProductForm');
    if (!form) return;

    const variantsJson = document.getElementById('ProductVariantsJson');
    if (!variantsJson) return;

    let variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch(e) {
      return;
    }

    const optionButtons = form.querySelectorAll('.product-option__value');
    const variantInput = document.getElementById('ProductVariantId');
    const priceEl = document.getElementById('ProductPrice');
    const addToCartBtn = document.getElementById('AddToCartBtn');
    const addToCartText = document.getElementById('AddToCartText');
    const skuEl = document.getElementById('ProductSku');
    const sellingPlanInput = document.getElementById('ProductSellingPlan');
    // Rendered outside the form, so query the document rather than the form.
    const preorderStockBlocks = document.querySelectorAll('[data-preorder-stock]');
    const preorderCrossLines = document.querySelectorAll('[data-preorder-cross]');

    // Track selected options
    const selectedOptions = {};
    form.querySelectorAll('.product-option').forEach(function(optionEl) {
      const index = parseInt(optionEl.dataset.optionIndex);
      const selected = optionEl.querySelector('.product-option__value.is-selected');
      if (selected) {
        selectedOptions[index] = selected.dataset.value;
      }
    });

    optionButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const optionIndex = parseInt(btn.dataset.optionIndex);
        const value = btn.dataset.value;

        // Update selected state
        const siblings = form.querySelectorAll(
          '.product-option__value[data-option-index="' + optionIndex + '"]'
        );
        siblings.forEach(function(s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');

        // Update selected label
        const label = form.querySelector('#OptionSelected-' + (optionIndex + 1));
        if (label) label.textContent = value;

        selectedOptions[optionIndex] = value;

        // Find matching variant
        const matchingVariant = variants.find(function(v) {
          return v.options.every(function(opt, i) {
            return selectedOptions[i] === undefined || selectedOptions[i] === opt;
          });
        });

        if (matchingVariant) {
          // Update variant ID
          if (variantInput) variantInput.value = matchingVariant.id;

          // Update URL
          const url = new URL(window.location.href);
          url.searchParams.set('variant', matchingVariant.id);
          window.history.replaceState({}, '', url.toString());

          // Update price
          if (priceEl) {
            const price = formatMoney(matchingVariant.price);
            const comparePrice = matchingVariant.compare_at_price;
            if (comparePrice && comparePrice > matchingVariant.price) {
              priceEl.innerHTML =
                '<span class="product-info__price-current product-info__price--sale">' + price + '</span>' +
                '<s class="product-info__price-compare">' + formatMoney(comparePrice) + '</s>';
            } else {
              priceEl.innerHTML =
                '<span class="product-info__price-current">' + price + '</span>';
            }
          }

          // Update availability
          if (addToCartBtn && addToCartText) {
            const isPreorder = addToCartBtn.dataset.preorder === 'true';
            if (matchingVariant.available) {
              addToCartBtn.disabled = false;
              addToCartText.textContent = isPreorder ? 'Preorder Now' : 'Add to Cart';
            } else {
              addToCartBtn.disabled = true;
              addToCartText.textContent = 'Sold Out';
            }
          }

          // Update SKU — hide the row when the variant has none, rather
          // than displaying "N/A"
          if (skuEl) {
            const skuSpan = skuEl.querySelector('span');
            if (skuSpan) skuSpan.textContent = matchingVariant.sku || '';
            skuEl.hidden = !matchingVariant.sku;
          }

          // Preorder stock counter — every variant's block is rendered by
          // Liquid (inventory counts aren't in the variant JSON), so switching
          // variants is just a matter of showing the right one.
          if (preorderStockBlocks.length || preorderCrossLines.length) {
            const selectedId = String(matchingVariant.id);
            preorderStockBlocks.forEach(function(block) {
              block.hidden = block.dataset.variantId !== selectedId;
            });
            // The cross-sell line is the mirror image: shown for every variant
            // except the one being viewed.
            preorderCrossLines.forEach(function(line) {
              line.hidden = line.dataset.variantId === selectedId;
            });
          }

          // Keep the selling plan in sync with the chosen variant
          if (sellingPlanInput) {
            const allocations = matchingVariant.selling_plan_allocations || [];
            if (allocations.length && allocations[0].selling_plan_id) {
              sellingPlanInput.value = allocations[0].selling_plan_id;
            }
          }

          // Update gallery if variant has media
          if (matchingVariant.featured_media) {
            const mediaId = String(matchingVariant.featured_media.id);
            const targetSlide = document.querySelector(
              '.product-gallery__slide[data-media-id="' + mediaId + '"]'
            );
            if (targetSlide) {
              document.querySelectorAll('.product-gallery__slide').forEach(function(s) {
                s.classList.remove('is-active');
              });
              document.querySelectorAll('.product-gallery__thumb').forEach(function(t) {
                t.classList.remove('is-active');
              });
              targetSlide.classList.add('is-active');
              const thumb = document.querySelector(
                '.product-gallery__thumb[data-media-id="' + mediaId + '"]'
              );
              if (thumb) thumb.classList.add('is-active');
            }
          }

          // Broadcast, so features that care about the selected variant can
          // listen instead of being wired into this function. Gift Credit mode
          // uses it; see initGiftCredit().
          document.dispatchEvent(new CustomEvent('variant:changed', {
            detail: { variant: matchingVariant }
          }));
        }
      });
    });

    // "Show the Signed & Numbered Edition" — clicks the real option buttons
    // rather than duplicating the variant-switching logic, so price, selling
    // plan, gallery and counter all update through the one code path above.
    document.querySelectorAll('[data-preorder-switch]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const values = (btn.dataset.preorderSwitch || '').split('||');
        values.forEach(function(value, i) {
          // Match on the dataset rather than an attribute selector — option
          // values contain spaces and ampersands ("Signed & Numbered Edition").
          optionButtons.forEach(function(opt) {
            if (parseInt(opt.dataset.optionIndex) !== i) return;
            if (opt.dataset.value !== value) return;
            if (!opt.classList.contains('is-selected')) opt.click();
          });
        });
        // The line the shopper just clicked is now hidden, so move focus
        // somewhere sensible instead of losing it to the document.
        if (addToCartBtn) addToCartBtn.focus({ preventScroll: true });
      });
    });
  }

  // ── 7. Quantity Selectors ─────────────────────────────────
  function initQuantitySelectors() {
    document.querySelectorAll('.quantity-selector').forEach(function(selector) {
      const input = selector.querySelector('.quantity-selector__input');
      if (!input) return;

      selector.querySelectorAll('.quantity-selector__btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const action = btn.dataset.action;
          let val = parseInt(input.value) || 1;
          if (action === 'increase') {
            val++;
          } else if (action === 'decrease') {
            var min = parseInt(input.getAttribute('min'));
            if (isNaN(min)) min = 0;
            val = Math.max(min, val - 1);
          }
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  // ── 7b. Gift Credit Amount ────────────────────────────────
  // Shopify has no open-ended "name your amount" field. The giving products
  // therefore carry a variant priced at $1.00, and the quantity box holds the
  // dollar figure. Here we relabel that box when the open-ended variant is
  // selected and show a running total, so the shopper reads dollars.
  //
  // The variant IDs come from Liquid via a metafield, so adding a second drive
  // needs no change here.
  function initGiftCredit() {
    const root = document.querySelector('[data-gift-credit]');
    if (!root) return;

    const input = document.getElementById('ProductQuantity');
    const promptEl = root.querySelector('[data-gc-prompt]');
    const totalEl = root.querySelector('[data-gc-total]');
    if (!input || !totalEl) return;

    const unitIds = (root.dataset.giftCreditUnits || '')
      .split(',').filter(Boolean);

    // A typo of an extra zero is a real risk when the box means dollars.
    const MAX_AMOUNT = 10000;
    const DEFAULT_AMOUNT = 25;

    const priceEl = document.getElementById('ProductPrice');

    let unitPrice = 0;      // cents, for the running total
    let isCustom = false;

    // initProductVariants() has already written the variant price into the
    // headline by the time our listener runs. On the per-dollar variant that
    // figure ($1.00) is not what the shopper is choosing, so replace it.
    function renderHeadline() {
      if (!priceEl || !isCustom) return;
      priceEl.innerHTML =
        '<span class="product-info__price-current">Choose your amount</span>';
    }

    function renderTotal() {
      const n = parseInt(input.value, 10);
      if (!n || n < 1 || !unitPrice) { totalEl.textContent = ''; return; }
      totalEl.textContent = 'Your gift: ' + formatMoney(n * unitPrice);
    }

    function apply(variant) {
      if (!variant) return;
      const wasCustom = isCustom;
      isCustom = unitIds.indexOf(String(variant.id)) !== -1;
      unitPrice = variant.price;

      root.classList.toggle('is-custom', isCustom);
      if (promptEl) promptEl.hidden = !isCustom;

      if (isCustom) {
        input.setAttribute('aria-label', 'Gift amount in US dollars');
        input.setAttribute('max', MAX_AMOUNT);
        // Coming from a fixed tier, "1" would read as a $1 gift. Offer a
        // sensible starting figure and select it so typing replaces it.
        if (!wasCustom) {
          input.value = DEFAULT_AMOUNT;
          input.focus({ preventScroll: true });
          input.select();
        }
      } else {
        input.setAttribute('aria-label', 'Product quantity');
        input.removeAttribute('max');
        // Leaving the custom box with "50" still in it would otherwise mean
        // fifty of the fixed tier — 50 x $25. Reset rather than surprise.
        if (wasCustom) input.value = 1;
      }
      renderHeadline();
      renderTotal();
    }

    input.addEventListener('input', function() {
      if (isCustom) {
        const n = parseInt(input.value, 10);
        if (n > MAX_AMOUNT) input.value = MAX_AMOUNT;
      }
      renderTotal();
    });
    input.addEventListener('change', renderTotal);

    document.addEventListener('variant:changed', function(e) {
      apply(e.detail && e.detail.variant);
    });

    // Sync with whatever variant the page loaded on (a ?variant= link, say).
    const json = document.getElementById('ProductVariantsJson');
    const idInput = document.getElementById('ProductVariantId');
    if (json && idInput) {
      try {
        const variants = JSON.parse(json.textContent);
        const current = variants.find(function(v) {
          return String(v.id) === String(idInput.value);
        });
        if (current) {
          // Seed without the focus-steal or the reset that a real change wants.
          isCustom = unitIds.indexOf(String(current.id)) !== -1;
          unitPrice = current.price;
          root.classList.toggle('is-custom', isCustom);
          if (promptEl) promptEl.hidden = !isCustom;
          if (isCustom) {
            input.setAttribute('max', MAX_AMOUNT);
            input.setAttribute('aria-label', 'Gift amount in US dollars');
            // Landing straight on this variant via ?variant=, "1" would read as
            // a $1 gift. Seed a starting figure — but no focus steal on load.
            input.value = DEFAULT_AMOUNT;
          }
          renderHeadline();
          renderTotal();
        }
      } catch (e) { /* variant JSON malformed; leave defaults */ }
    }
  }

  // ── 8. Cart Item Updates ──────────────────────────────────
  function initCartItems() {
    // Remove buttons
    document.querySelectorAll('[data-remove-item]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const key = btn.dataset.removeItem;
        updateCartItem(key, 0);
      });
    });

    // Quantity changes in cart
    document.querySelectorAll('.cart-item .quantity-selector__input').forEach(function(input) {
      input.addEventListener('change', function() {
        const key = input.dataset.key;
        const qty = parseInt(input.value);
        if (key) updateCartItem(key, qty);
      });
    });

    document.querySelectorAll('.cart-item .quantity-selector__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const key = btn.dataset.key;
        const input = btn.closest('.quantity-selector').querySelector('.quantity-selector__input');
        if (key && input) {
          setTimeout(function() {
            updateCartItem(key, parseInt(input.value));
          }, 100);
        }
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      window.location.reload();
    })
    .catch(function(err) {
      console.error('Cart update error:', err);
    });
  }

  // ── 9. Sort By ────────────────────────────────────────────
  function initSortBy() {
    const select = document.querySelector('[data-sort-by]');
    if (!select) return;

    select.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  }

  // ── 10. Add to Cart (product cards) ──────────────────────
  function initAddToCart() {
    document.querySelectorAll('.product-card__form').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const btn = form.querySelector('.btn--add-to-cart');
        const id = form.querySelector('input[name="id"]').value;

        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding...';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          if (btn) {
            btn.textContent = 'Added!';
            btn.style.backgroundColor = '#2C5F2E';
            setTimeout(function() {
              btn.disabled = false;
              btn.textContent = 'Add to Cart';
              btn.style.backgroundColor = '';
            }, 2000);
          }
          // Update cart count
          return fetch('/cart.js');
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          const countEl = document.querySelector('.site-header__cart-count');
          if (countEl) {
            countEl.textContent = cart.item_count;
          } else if (cart.item_count > 0) {
            const cartLink = document.querySelector('.site-header__cart');
            if (cartLink) {
              const span = document.createElement('span');
              span.className = 'site-header__cart-count';
              span.setAttribute('aria-hidden', 'true');
              span.textContent = cart.item_count;
              cartLink.appendChild(span);
            }
          }
        })
        .catch(function(err) {
          console.error('Add to cart error:', err);
          if (btn) {
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
          }
        });
      });
    });
  }

  // ── 11. Utilities ─────────────────────────────────────────
  function formatMoney(cents) {
    const dollars = cents / 100;
    return '$' + dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

})();
